import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { Sidebar } from '@/components/layout/Sidebar';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { BloombergRadioButton } from '@/components/trading/BloombergRadioButton';
import { PortfolioOverview } from '../../components/portfolio';

const PortfolioOverviewPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col w-full">
      <Navigation 
        activeView="trader"
        setActiveView={() => {}}
        showRoles={false}
        setShowRoles={() => {}}
      />
      <div className="flex-1 flex">
        <div className="hidden md:block">
          <Sidebar />
        </div>
        <main className="flex-1 relative p-6 pb-16 w-full max-w-[1920px] mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => navigate(-1)}
                className="mr-1"
              >
                <ArrowLeft className="h-5 w-5" />
              </Button>
              <h1 className="text-2xl font-semibold">Portfolio Overview</h1>
            </div>
            <Button onClick={() => {}}>
              New Strategy
            </Button>
          </div>
          <PortfolioOverview />
        </main>
      </div>
      
      {/* Bloomberg Radio Button inside main container */}
      <div className="fixed bottom-4 right-4 z-50">
        <BloombergRadioButton />
      </div>
    </div>
  );
};

export default PortfolioOverviewPage;